// components/CartContainer.jsx - با بهبود نمایش loading
import React from 'react';
import DesktopCart from './DesktopCart';
import MobileCart from './MobileCart';
import ContinueButtons from './ContinueButtons';
import Loader from '../../Loader';

const CartContainer = ({
  displayProducts,
  user,
  gold,
  translate,
  currentView,
  setCurrentView,
  deleteFromCart,
  deleteThisProductId,
  cart_items,
  cart_credit,
  totals,
  totalForNotLogginUser,
  onNext,
  onBackToStore,
  showLoader,
}) => {
  // اگر در حال loading است، loader نشان بده
  if (!!showLoader && !displayProducts) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Loader />
        <p style={{ color: '#6b7280', fontSize: '14px' }}>در حال بارگذاری سبد خرید...</p>
      </div>
    );
  }

  return (
    <>
      <DesktopCart
        displayProducts={displayProducts}
        user={user}
        gold={gold}
        translate={translate}
        deleteFromCart={deleteFromCart}
        deleteThisProductId={deleteThisProductId}
        cart_items={cart_items}
        cart_credit={cart_credit}
      />

      <MobileCart
        displayProducts={displayProducts}
        user={user}
        gold={gold}
        translate={translate}
        currentView={currentView}
        setCurrentView={setCurrentView}
        deleteFromCart={deleteFromCart}
        deleteThisProductId={deleteThisProductId}
        cart_items={cart_items}
        cart_credit={cart_credit}
      />

      <ContinueButtons user={user} translate={translate} totals={totals} totalForNotLogginUser={totalForNotLogginUser} onNext={onNext} onBackToStore={onBackToStore} />
    </>
  );
};

export default CartContainer;
